const $ = require('jquery');
global.$ = global.jQuery = $;

"use strict";

var adx = (function () {
	"use strict";
	var
		self = {},
		functionStack = [];

	/*
	 * load start function in order
	 *
	 * @type {function(?number=, function)}
	 */
	self.load = function () {
		var index, i, argLength = arguments.length;

		for (i = 0; i < argLength; i++) {

			if (typeof arguments[i] === 'number') {
				index = arguments[i];
			}
			if (typeof arguments[i] === 'function') {
				if (index === undefined) {
					index = functionStack.length;
					functionStack[index] = [];
				} else {
					if (functionStack[index] === undefined) {
						functionStack[index] = [];
					}
				}
				functionStack[index].push(arguments[i]);

				break;
			}
		}
	};


	function init() {
		var sub, arr, f;

		for (sub in functionStack) {
			if (functionStack.hasOwnProperty(sub)) {
				arr = functionStack[sub];
				for (f in arr) {
					if (arr.hasOwnProperty(f)) {
						arr[f]();
					}
				}
			}
		}
	}


	if (window.addEventListener) {
		window.addEventListener('load', init, false);
	} else {
		window.attachEvent("onload", init);
	}
	return self;
}());

adx.addParameterToUrl = function(url, key, value) {
	if (typeof url !== 'string' || url.length == 0) {
		return '?' + key + '=' + encodeURIComponent(value);
	}

	var questionPosition = url.indexOf('?');
	var hashPosition = url.indexOf('#');

	var anchor = '';
	if (hashPosition != -1) {
		anchor = url.substring(hashPosition);
		url = url.substring(0, hashPosition);
	}

	return url + (questionPosition != -1 ? '&' : '?') + key + '=' + encodeURIComponent(value) + anchor;
};

adx.fixFlashZIndex = function() {
	$('body').find('embed').attr({'wmode': 'transparent'});
	$('iframe').each(function() {
		var obj = $(this);
		var url = obj.attr('src');
		if (url !== undefined) {
			url = adx.addParameterToUrl(url, 'wmode', 'transparent');
			obj.attr('src', url);
		}
	});
};

/* Scrollable Menu */
var ScrollableMenu = function(container){
	this.container = $(container);
	this.scrollLink = $('.js-scroll-to');

	this.init();
};

ScrollableMenu.prototype.init = function(){
	var cmp = this;

	cmp.container.addClass('is-fixed');

	cmp.scrollLink.on('click',function(e){
		e.preventDefault();
		var crt = $(this);
		if(!crt.hasClass('is-active')){
			cmp.scrollLink.removeClass('is-active');
			$(this).addClass('is-active');
		}
		var blockWeNeed = $("#"+crt.data('id'));
		if(blockWeNeed.length !== 0){
			e.preventDefault();
			$('html,body').animate({
				scrollTop: blockWeNeed.offset().top
			});
		}
	});

};
/* /Scrollable Menu */

$(function() {
	adx.fixFlashZIndex();

	/*Captcha*/
	var question = $('#eq_question');
	if (question.length) {
		var captchaKeyId = $('#captchaKeyId').val();
		var lang = question.attr('lang');
		var url = location.protocol + '//' + location.host + '/script/core/captcha/';

		var expression = '';
		var eSign = '';
		$.get(url, {type: 'sign', l : lang, 'captchaKeyId': captchaKeyId}, function(data){
			eSign = data;
			$.get(url, {type: 'first', l : lang, 'captchaKeyId': captchaKeyId}, function(data){
				expression = data;
				$.get(url, {type: 'second', l : lang, 'captchaKeyId': captchaKeyId}, function(data){
					expression += ' ' + eSign + ' ' + data;
					question.html(expression);
				}, 'text');
			}, 'text');
		}, 'text');
	}

	/* Bulma modal */
	$('.modal-button').on('click', function() {
		var target = $(this).data('target');
		var $body = $('body');
		var bodyCurrentWidth = $body.width();
		$('html').addClass('is-clipped');
		$body.css({
			paddingRight: $body.width() - bodyCurrentWidth
		});
		$(target).addClass('is-active');
	});

	$('.modal-background, .modal-close').on('click', function() {
		$('html').removeClass('is-clipped');
		$('body').css({
			paddingRight: 0
		});
		$(this).parent().removeClass('is-active');
	});

	/* Magnific Popup, ajax */
	$('.simple-ajax-popup-align-top').magnificPopup({
		type: 'ajax',
		alignTop: true,
		overflowY: 'scroll' // as we know that popup content is tall we set scroll overflow by default to avoid jump
	});
	if ($('.js-simple-ajax-popup').hasClass('video-splitter') && $('.js-simple-ajax-popup').hasClass('en')){
		$('.js-simple-ajax-popup').attr('href', '#external-form');
		$('.js-simple-ajax-popup').magnificPopup({
			type: 'inline'
		});
	}else {
		$('.js-simple-ajax-popup').magnificPopup({
			type: 'ajax'
		});
	}

	/* Magnific Popup with Video */
	// noinspection HtmlDeprecatedAttribute
	$('.js-video').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
		// Changes iFrame to support Youtube state changes (so we can close the video when it ends)
		iframe: {
			markup:
				'<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
				'</div>' +
				'<div class="mfp-bottom-bar">' +
				'<div class="mfp-title"></div>' +
			'</div>',
			patterns: {
				youtube: {
					index: 'youtube.com/',
					id: function(url) {
						var m = url.match(/[?&\\]v=([^\\?&]+)/);
						if (!m || !m[1]) return null;
						var res = m[1] + '?';
						var t = url.match(/[\\?&]t=([^\\?&]+)/);
						if (t && t[1])
							res = res + 'start=' + t[1] + '&';
						return res;
						},
					src: '//www.youtube.com/embed/%id%autoplay=1'
				}
			}
		}
	});

	/* Magnific Popup, Inline */
	$('.js-modal').magnificPopup({
		type: 'inline',
		closeBtnInside: true
	});

	/* Magnific Popup, Image */
	$('.js-image').magnificPopup({
		type: 'image',
		closeBtnInside: true
	});

	/* Magnific Popup, close */
	$(document).on('click', '.js-modal-close', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});

	$('.js-zoom-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: function(item) {
				return item.el.attr('title') + ' &middot; <a class="image-source-link" href="'+item.el.attr('data-source')+'" target="_blank">download</a>';
			}
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300, // don't forget to change the duration also in CSS
			opener: function(element) {
				return element.find('img');
			}
		}

	});

	/* Slick slider */
	$('.js-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 3,
		arrows: false,
		dots: true,
		responsive: [
			{
				breakpoint: 801,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.js-slider-author-text').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: true,
		dots: false
	});

	$('.js-slider-author-picture-text').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: true,
		dots: true
	});

	$('.js-slider-picture-text').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
		adaptiveHeight: true
	});


	/* Search form in header  */
	$('.js-search-trigger').on('click', function() {
		$('.search-navbar').show();
		$('.search-navbar .search-navbar__input').focus();
	});

	$('.js-search-navbar-close').on('click', function() {
		$('.search-navbar').hide();
	});

	/* FAQ */
	$(document).ready(function(){
		var $button = $('.js-more-button');
		if ($button.length) {
			$button.on('click', function () {
				var $moreButton = $(this);
				var $moreBlock = $(this).prev('.js-more-block');
				// var $moreArticles = $('.js-more-articles-button');
				$moreButton.hide('slow');
				$moreBlock.slideToggle('slow');
			})
		}
	});

	/* Show all features */
	$('.js-features').on('click', function () {
		var $block = $(this).prev('div.is-hidden');
		$block.animate({
			opacity: 'toggle',
			height: 'toggle'
		}, 400);
	});

	/* Show more items with button text change */
	$('.js-show-more').on('click', function () {
		var $this = $(this),
			$target = $this.prev('div.is-hidden'),
			$sButtonText = $this.data('show'),
			$hButtonText = $this.data('hide');

		if ( $target.is(':visible') ) {
			$target.fadeOut();
			$this.text($sButtonText);
		} else {
			$target.fadeIn();
			$this.text($hButtonText);
		}
	});

	/* Toggle block by 'data-id' */
	$('.js-toggle').on('click', function () {
		var $block = $("#"+$(this).data('id'));
		$block.animate({
			opacity: 'toggle',
			height: 'toggle'
		}, 400);
	});

	/* Toggle block by 'data-id' width descriptions (Video Editing SDK) */
	$('.js-description').on('click', function () {

		var $block = $('#' + $(this).data('id') ),
			$icon = $('#' + $(this).data('id') + '-icon');

		$block.animate({
			opacity: 'toggle',
			height: 'toggle'
		}, 400, function() {
			if ( $block.is(':visible') ) {
				$icon.fadeOut(200);
			} else {
				$icon.fadeIn(200);
			}
		});
	});

	/* Selector */
	$(document).ready(function(){
		if ($('.js-selector').length) {
			$(this).find('.selector-tabs__item').first().addClass('is-active');
			$(this).find('.os-version').first().removeClass('is-hidden');

			$(this).find('.selector-tabs__item').on('click', function (e) {
				var $this = $(this);
				var $button = $('.selector-tabs__item.is-active'),
					$ct = $( '#' + $button.data('src') ),
					$target = $( '#' + $this.data('src') );

				if ( ($target.length !== 0) && !($target.is(':visible')) ) {
					e.preventDefault();
					$button.removeClass('is-active');
					$this.addClass('is-active');
					$ct.fadeOut(0, function() {
						$target.fadeIn();
					});
				}
			})
		}
	});


	/* Scroll up */
	$('.js-scrollup').on('click', function () {
		$('html,body').animate({
			scrollTop: 0
		}, 300);
	});

	$(window).on('load resize scroll', function () {
		var scrollupBtn = $('.js-scrollup');
		var scrollY = window.pageYOffset || document.documentElement.scrollTop;

		var navHeight = document.getElementsByClassName('navbar')[0].offsetHeight;
		var footerHeight = document.getElementsByClassName('footer-bottom')[0].offsetHeight;

		var scrollupBottom = document.documentElement.offsetHeight - document.documentElement.clientHeight - scrollY;

		if ( scrollupBottom < footerHeight ) {
			scrollupBtn.css("bottom", (-1)*scrollupBottom + footerHeight - 5);
		}
		else {
			scrollupBtn.css("bottom", "50px");
		}

		// Appearance
		if (scrollY > navHeight) {
			scrollupBtn.fadeIn();
		}
		else {
			scrollupBtn.fadeOut();
		}
	});

	/* Fixed navigation  */
	$(window).on('load resize scroll', function () {
		var navBar = $('.js-navbar');
		if(navBar.length !== 0){
			var scrolled = window.pageYOffset || document.documentElement.scrollTop;
			if(scrolled > navBar.height()) {
				navBar.addClass('is-fixed');
			}
			else {
				navBar.removeClass('is-fixed');
			}
		}
	});

	/* Arrow */
	var isArrow = true;

	function animateArrow() {
		var $arrow = $('.js-arrow'),
			$arrowWidth = $arrow.data('width'),
			$arrowHeight = $arrow.data('height');
		$arrow.animate({
			width: $arrowWidth,
			height: $arrowHeight,
			opacity: 1
		}, 700, function() {
			isArrow = false;
		});
	}

	$(document).ready(function(){
		var arrows = $('.js-arrow');
		if (arrows.length) {
			if (($(window).scrollTop() + $(window).height() * 2) > arrows.offset().top) {
				if (isArrow) {
					animateArrow();
				}
			}
		}
	});

	$(window).on('scroll', function () {
		var arrows = $('.js-arrow');
		if ( arrows.length ) {
			if ( ($(window).scrollTop() + $(window).height()*0.65) > arrows.offset().top ) {
				if (isArrow) {
					animateArrow();
				}
			}
		}
	});

	/* Footer nav fix */
	$(document).ready(function(){
		var $spacer = $('.footer-nav-spacer');
		if ($spacer.length) {
			$spacer.css('height',$('.footer__grid').height())
		}
	});

	/* Subscribe form */
	$('#subscribe_form').submit(function(e) {
		var $form = $(this);
		var $subscribeSection = $('#subscribe_section');

		if ($form.hasClass('working')) {
			return false;
		}
		$form.addClass('working');

		var data = $form.serialize();
		var url = $form.attr('action');
		var type = $form.attr('method');
		console.log('Subscribe', type, url, data);

		$.ajax({
			type: type,
			url: url,
			data: data
		}).done(function(response) {
			var result = jQuery.parseJSON(response);
			if (result.status) {
				$subscribeSection.html($('#subs_form_positive_result').html());
			} else if (result.errors) {
				$('.js-subscribe_form__error').empty();
				var errors = result.errors;
				$.each(errors, function(key, value) {
					var $errorField = $('.js-subscribe_form__error_' + key);
					if ($errorField.length) {
						$errorField.append(value);
					}
				});
				$form.removeClass('working');
			} else  {
				$subscribeSection.html($('#subs_form_negative_result').html());
			}
		}).fail(function() {
			$subscribeSection.html($('#subs_form_negative_result').html());
		});

		e.preventDefault();
	});

	/* Download product form */
	$('.js-download-sdk').magnificPopup({
		type: 'ajax',
		closeBtnInside: 'true',
		callbacks: {
			ajaxContentAdded: function () {
				// Ajax content is loaded and appended to DOM
				$.ajax({
					type: "GET",
					url: "/static/prj/js/countries.js",
					dataType: "script",
					cache: false,
					success: function( html ){
						$(".js-countries-list").append( html );
					}
				});

				var mp = $.magnificPopup.instance;

				if (($(mp.currItem.el).length > 0) && ($(mp.currItem.el[0]).attr('data-platform'))) {
					var platform = $(mp.currItem.el[0]).data('platform'),
						platformName = $(mp.currItem.el[0]).data('platform-name'),
						elPlatform = document.getElementById(platform),
						rowPlatform = $('#' + platform).closest('.field');

					if (platform && elPlatform && rowPlatform) {
						elPlatform.checked = true;
						rowPlatform.hide();
						if (platformName) {
							$('.js-platform-name').each(function(){
								$(this).html(platformName);
							})
						}
					}
				}

				$('#download_form').submit(function (e) {
					e.preventDefault();
					var $form = $(this);

					if ($form.hasClass('working')) {
						return false;
					}
					$form.addClass('working');


					var pathname = window.location.pathname;
					var langs = ['en', 'ru', 'de', 'it', 'es', 'pt', 'ja', 'zh'];
					var lang;
					if (pathname[0] === '/' && pathname[3] === '/' && langs.indexOf(pathname.substr(1, 2))) {
						lang = pathname.substr(1, 2);
					} else {
						lang = 'en';
					}

					var data = $form.serializeArray();
					data.push({name: "lang_code", value: lang});

					// var p = 1;
					$.ajax({
						type: $form.attr('method'),
						url: $form.data('action'),
						data: $.param(data)
					}).done(function(response) {
						var result = jQuery.parseJSON(response);
						if (result.status) {
							$.magnificPopup.open({
								items: {
									src: '/download-sdk-success/?popup=1'
								}
							})
						} else {
							$.magnificPopup.open({
								items: {
									src: '/download-sdk-error/?popup=1'
								}
							})
						}
					}).fail(function() {
						$.magnificPopup.open({
							items: {
								src: '/download-sdk-fail/?popup=1'
							}
						})
					});
				});
			}
		}
	});


	/* Scrollable Menu */
	$('.js-menu').each(function(){
		new ScrollableMenu(this);
	});

	/* Tooltips */
	$('.js-tooltip').each(function(){
		new Tooltips(this);
	});
});

/* Main Product Menu */
$(document).ready(function(){
	$(this).find('.js-tag_item').on('click', function () {
		var $this = $(this);
		var $disabledElements = $('.js-element_item.is-disabled');

		if($this.hasClass('is-active')) {
			$disabledElements.removeClass('is-disabled');
			$this.removeClass('is-active');
		} else {
			var $targetElements = $('.js-element_item:not(.' + $this.data('src') + ')'),
				$activeTag = $('.js-tag_item.is-active');
			$disabledElements.removeClass('is-disabled');
			$targetElements.addClass('is-disabled');
			$activeTag.removeClass('is-active');
			$this.addClass('is-active');
		}
	})
});
/* /Main Product Menu */

/* Tooltip */
let Tooltips = function(container){
	this.container = $(container);
	this.init();
};

Tooltips.prototype.init = function() {
	var obj = this;

	obj.container.mouseenter(function() {
		$(this).closest('.tooltip').find('.tooltip__text')
			.css('display', 'block')
			.animate({
				opacity: 1
			}, 150)
		})
		.mouseleave(function() {
			$(this).closest('.tooltip').find('.tooltip__text')
				.animate({
					opacity: 0
				}, 50, function () {
					$(this).css('display', 'none')
				})
		});
};

/* Search Lang Title */
$(function() {
	$('.lang_title').on('click', function () {
		var url = window.location.toString();
		var langPos = url.indexOf('&lang=');

		if (~langPos) {
			url = url.substring(0, langPos);
		}

		window.location = url + '&lang=' + $(this).data('lang');
	});
});
/* /Search Lang Title */
// const jQuery = require('jQuery')
// // other packages here
//
// window.$ = window.jQuery = jQuery

